module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-logout"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.logoutMessageHTML
    }
  }), _c('form', {
    staticClass: "w-login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitLogin.apply(null, arguments)
      }
    }
  }, [_vm._m(0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "type": "submit",
      "autofocus": "autofocus"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Log in again")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10ee2996","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Logout/Logout.vue
// module id = 586
// module chunks = 1